module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-button', {
    attrs: {
      "type": "warning",
      "size": _vm.btnSize,
      "disabled": _vm.btnDisable,
      "icon": "user"
    },
    on: {
      "click": _vm.addCLassForStu
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "480",
      "footer-hide": ""
    },
    model: {
      value: (_vm.modalShow),
      callback: function($$v) {
        _vm.modalShow = $$v
      },
      expression: "modalShow"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "font-size": "15px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-information-circle"
    }
  }), _vm._v(" "), _c('span', [_vm._t("default")], 2)], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.formStu,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择已有分组:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "175px"
    },
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.formStu.groupId),
      callback: function($$v) {
        _vm.$set(_vm.formStu, "groupId", $$v)
      },
      expression: "formStu.groupId"
    }
  }, _vm._l((_vm.groupList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.group_name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('Divider'), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "266px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.modalConfirm
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.modalCancel
    }
  }, [_vm._v("取消")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-94d710b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/componentsEdu/classGroup.vue
// module id = 720
// module chunks = 1